//#region src/components/CoreIntelligenceIcon/core-intelligence-icon-paths.ts
/**
* Corners of the open cube's two visible faces. The drawn cube is not a strict
* isometric projection: its front corner sits left of and below the shell's
* centre, so these points are the source of truth rather than derived values.
*/
const ICON_CUBE = {
	bottom: [7.91797, 14.7752],
	center: [7.91797, 8.97884],
	lowerLeft: [2.58464, 11.463],
	lowerRight: [13.2513, 11.463],
	upperLeft: [2.58464, 5.63232],
	upperRight: [13.2513, 5.63232]
};
const quad = (points) => `M${points.map(([x, y]) => `${x} ${y}`).join("L")}Z`;
const ICON_RIGHT_FACE = quad([
	ICON_CUBE.upperRight,
	ICON_CUBE.center,
	ICON_CUBE.bottom,
	ICON_CUBE.lowerRight
]);
const ICON_RIGHT_FACE_OPACITY = .4;
const ICON_LEFT_FACE = quad([
	ICON_CUBE.upperLeft,
	ICON_CUBE.center,
	ICON_CUBE.bottom,
	ICON_CUBE.lowerLeft
]);
const ICON_LEFT_FACE_OPACITY = .65;
const ICON_SHELL = "M6.47656 0.407989C7.41922 -0.135996 8.58078 -0.135996 9.52344 0.407989L14.4756 3.26541C15.4187 3.80968 15.9999 4.81617 16 5.90506V11.6179C16 12.7068 15.4186 13.7133 14.4756 14.2576L9.52344 17.116C8.5808 17.6599 7.4192 17.6599 6.47656 17.116L1.52441 14.2576C0.581406 13.7132 3.65972e-05 12.7068 0 11.6179V5.90506C0.000118328 4.81617 0.581295 3.80968 1.52441 3.26541L6.47656 0.407989Z";
const ICON_CAVITY = "M8.76172 3.81619C8.29039 3.5442 7.70961 3.54421 7.23828 3.81619L4.0957 5.62967C3.62422 5.90177 3.33315 6.40466 3.33301 6.949V10.575C3.33304 11.1195 3.62411 11.6231 4.0957 11.8953L7.23828 13.7088C7.70957 13.9807 8.29045 13.9807 8.76172 13.7088L11.9043 11.8953C12.3759 11.6231 12.666 11.1194 12.666 10.575V6.949C12.6659 6.40471 12.3757 5.90179 11.9043 5.62967L8.76172 3.81619Z";
const ICON_CORE = "M7.61914 5.90408C7.85476 5.76814 8.14524 5.76816 8.38086 5.90408L10.2852 7.00369C10.521 7.13977 10.667 7.39159 10.667 7.66385V9.86111C10.667 10.1334 10.521 10.3852 10.2852 10.5213L8.38086 11.6199C8.14519 11.7559 7.85481 11.7559 7.61914 11.6199L5.71484 10.5213C5.47904 10.3852 5.33302 10.1334 5.33301 9.86111V7.66385C5.33301 7.39159 5.47903 7.13977 5.71484 7.00369L7.61914 5.90408Z";
//#endregion
export { ICON_CAVITY, ICON_CORE, ICON_CUBE, ICON_LEFT_FACE, ICON_LEFT_FACE_OPACITY, ICON_RIGHT_FACE, ICON_RIGHT_FACE_OPACITY, ICON_SHELL };

//# sourceMappingURL=core-intelligence-icon-paths.js.map